export default {
  contextRoot: process.env.CONTEXT_ROOT || process.env.RAZZLE_CONTEXT_ROOT,
  whatsappNumber:
    process.env.WHATSAPP_NUMBER || process.env.RAZZLE_WHATSAPP_NUMBER,
  googleServicesApiKey:
    process.env.GOOGLE_SERVICES_API_KEY ||
    process.env.RAZZLE_GOOGLE_SERVICES_API_KEY,
  coreApiKey: process.env.CORE_API_KEY || process.env.RAZZLE_CORE_API_KEY,
  memcachedConnectionUrl:
    process.env.MEMCACHED_CONNECTION_URL ||
    process.env.RAZZLE_MEMCACHED_CONNECTION_URL,
  cacheTimeoutMinutes:
    process.env.CACHE_TIMEOUT_MINUTES ||
    process.env.RAZZLE_CACHE_TIMEOUT_MINUTES,
  nodeEnv: process.env.NODE_ENV,
  gitRevision: process.env.GIT_REVISION,
  environment: process.env.ENVIRONMENT,
  gympassHost: process.env.GYMPASS_HOST || process.env.RAZZLE_GYMPASS_HOST,
  newFlowForkUrl: process.env.NEW_FLOW_FORK_URL,
  brBlipAppKey: process.env.BR_BLIP_APP_KEY,
  usBlipAppKey: process.env.US_BLIP_APP_KEY,
  segmentId: process.env.SEGMENT_ID,
  cookiePolicyVersion: process.env.COOKIE_POLICY_VERSION,
}
